export class FindDataAutoComplete<T> {
    criteria?: T;
    limit: number

    constructor(criteria?: T, limit?: number) {
        this.criteria = criteria || undefined;
        this.limit = limit || Number(process.env.REACT_APP_AUTO_COMPLETE_LIMIT) || 10
    }
}
